// The resting grey: in the editor every room but the picked one wears it
export const FLOOR_PLAN_ROOM_RGB: [number, number, number] = [148, 163, 184];
// The teal of a live room: the rooms level, the entered room, the export and the picked one in the editor
export const FLOOR_PLAN_ROOM_ACTIVE_RGB: [number, number, number] = [
  13, 148, 136,
];
